import * as types from '../actions/types';

const initialState = {
    searchtrainerdata:[],
    success:false
}

export default function TrainerSearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_TRAINER:
            return {
               
                searchtrainerdata:action.payload,
                success:true
            } 
        default:
            return state
    }
}
